import axios from "axios";
import { FileMenuJson, FileRegistrationResultJson } from "../api/requests";
import { MaintenanceJson } from "../api/requests/maintenance";

export const axiosInstance = axios.create({ baseURL: "" });

const fileMenuJson = new FileMenuJson(axiosInstance);
const fileRegistrationResultsJson = new FileRegistrationResultJson(
  axiosInstance,
);
const maintenanceJson = new MaintenanceJson(axiosInstance);

export { fileMenuJson, fileRegistrationResultsJson, maintenanceJson };
